/**
 * Throws an exception for the case when popover trigger doesn't have a valid ui-popover instance
 * @docs-private
 */
export function throwUiPopoverMissingError() {
  throw Error(`uiPopoverTriggerFor: must pass in an ui-popover instance.

    Example:
      <ui-popover #popover="uiPopover"></ui-popover>
      <button [uiPopoverTriggerFor]="popover"></button>`);
}

/**
 * Throws an exception for the case when popover's x-position value isn't valid.
 * In other words, it doesn't match 'before' or 'after'.
 * @docs-private
 */
export function throwUiPopoverInvalidPositionX() {
  throw Error(`xPosition value must be either 'before' or after'.
      Example: <ui-popover xPosition="before" #popover="uiPopover"></ui-popover>`);
}

/**
 * Throws an exception for the case when popover's y-position value isn't valid.
 * In other words, it doesn't match 'above' or 'below'.
 * @docs-private
 */
export function throwUiPopoverInvalidPositionY() {
  throw Error(`yPosition value must be either 'above' or below'.
      Example: <ui-popover yPosition="above" #popover="uiPopover"></ui-popover>`);
}

/**
 * Throws an exception for the case when a popover is assigned
 * to a trigger that is placed inside the same popover.
 * @docs-private
 */
export function throwUiPopoverRecursiveError() {
  throw Error(
    `uiPopoverTriggerFor: popover cannot contain its own trigger. Assign a popover that is ` +
      `not a parent of the trigger or move the trigger outside of the popover.`
  );
}
